<template>
  <div>
    <home-content></home-content>
    <eu-law></eu-law>
  </div>
</template>

<script>
// @ is an alias to /src

import HomeContent from "@/components/home/HomeContent";
import EuLaw from "@/components/home/EuLaw";

export default {
  name: "Home",
  components: {
    EuLaw,
    "home-content": HomeContent
  }
};
</script>
